import React from "react";

import { Header, Icon, ProfileMenu, Avatar } from "pepsico-ds";
import "../../theme/PeacockDesign.css";
import userAvatar from "../../assets/images/user.png";
import "./AppHeader.css";
interface AppHeaderProps {
  logoutClose: (index: number) => void;
}
const AppHeader: React.FC<AppHeaderProps> = ({ logoutClose }) => {
  return (
    <Header
      className="appHeader"
      appLogoProps={{
        appName: "SpendWise Hub",
      }}
      rightToolbar={[
        {
          dropdownContent: (
            <ProfileMenu
              className="profileMenu"
              onUpdate={logoutClose}
              options={[
                {
                  separator: false,
                  showBadge: false,
                  showDotIcon: false,
                  showLink: false,
                  title: "My Profile",
                  type: "row",
                },
                {
                  separator: false,
                  showBadge: false,
                  showDotIcon: false,
                  showLink: false,
                  title: "Logout",
                  type: "row",
                },
              ]}
              style={{
                width: "280px",
              }}
            />
          ),
          icon: (
            <>
              <Icon
                alt="alt value"
                svg={
                  <Avatar
                    imageUrl={userAvatar}
                    name="Jon Do"
                    size="small"
                    type="image"
                  />
                }
              />
              <Icon
                alt="alt value"
                className="$color-icon-white"
                icon="arrow_drop_down"
                size="large"
              />
            </>
          ),
          onClickIcon: () => {},
        },
      ]}
      onClickLeftIcon={() => {
        console.log("Left icon clicked");
      }}
    />
  );
};

export default AppHeader;
